var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgLinkinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.1924 6.364l4.4548-4.4548c1.0544-1.0544 2.8589-.9595 4.0305.2121 1.1715 1.1716 1.2665 2.9761.2121 4.0305l-4.4548 4.4548h0M6.364 9.1924l-4.4548 4.4548c-1.0544 1.0544-.9595 2.8589.2121 4.0305 1.1716 1.1715 2.9761 1.2665 4.0305.2121l4.4548-4.4548h0",
  stroke: "currentColor",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.728 5.6569L14.142 7.071l-7.071 7.071-1.4142-1.4142z"
}))));

export default SvgLinkinline;